import { Route, Routes } from 'react-router-dom';

import CheckoutRoutes from './Carts.routes';
import { StoreRoutes, StoresRoutes } from './Stores.routes';

/**
 *
 * All Routes for the shop package
 * Should be routed to base/shop
 */
const ShopRoutes = () => {
  return (
    <Routes>
      <Route path="stores/*" element={<StoresRoutes />} />
      <Route path="carts/*" element={<CheckoutRoutes />} />

      <Route path="*" element={<StoreRoutes />} />
    </Routes>
  );
};

export { ShopRoutes };
